import React, { useEffect, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import axios from "axios";
import { useSelector } from "react-redux";
import am5geodata_worldIndiaLow from "@amcharts/amcharts5-geodata/worldIndiaLow";
import countryToFlagCode from "../CountryFlag/CountryFlag";
// import earth from "../Assets/earth.png";
import blueLocation from "../Assets/locationBlue.png";
import greenPin from "../Assets/greenPin.png";
import yellowPin from "../Assets/yellowPin.png";
const MapChart = ({ selectedHeader, currency }) => {
  const [countryData, setCountryData] = useState([]);
  const DDPValues = useSelector((state) => state.DDPData.DDP);

  const hardCodedCoordinates = {
    Brazil: { latitude: -14.235, longitude: -51.9253 },
    China: { latitude: 35.8617, longitude: 104.1954 },
    France: { latitude: 46.6034, longitude: 1.8883 },
    Germany: { latitude: 51.1657, longitude: 10.4515 },
    India: { latitude: 20.5937, longitude: 78.9629 },
    "South Africa": { latitude: -30.5595, longitude: 22.9375 },
    "Sri Lanka": { latitude: 7.8731, longitude: 80.7718 },
    "United Kingdom": { latitude: 55.3781, longitude: -3.436 },
    USA: { latitude: 37.0902, longitude: -95.7129 },
    Australia: { latitude: -25.2744, longitude: 133.7751 },
    Italy: { latitude: 41.8719, longitude: 12.5674 },
    Netherlands: { latitude: 52.1326, longitude: 5.2913 },
    Philippines: { latitude: 12.8797, longitude: 121.774 },
    Spain: { latitude: 40.4637, longitude: -3.7492 },
    Indonesia: { latitude: -0.7893, longitude: 113.9213 },
  };

  const getCountryCoordinates = async (countryName) => {
    try {
      // if (!countryName) return null;
      if (hardCodedCoordinates[countryName]) {
        return hardCodedCoordinates[countryName];
      }

      if (
        countryName !== undefined &&
        countryName !== null &&
        countryName !== "undefined" &&
        countryName !== ""
      ) {
        const response = await axios.get(
          `https://nominatim.openstreetmap.org/search?country=${countryName}&format=json&limit=1`
        );

        if (response.data && response.data.length > 0) {
          const { lat, lon } = response.data[0];
          return { latitude: parseFloat(lat), longitude: parseFloat(lon) };
        }
      }
    } catch (error) {}

    return null;
  };

  const prevKeysRef = React.useRef([]);

  useEffect(() => {
    if (!DDPValues || DDPValues.length === 0) return;

    const currentKeys = Object.keys(DDPValues[0] || {});

    const prevKeys = prevKeysRef.current;
    const keysChanged =
      currentKeys.length !== prevKeys.length ||
      currentKeys.some((key, i) => key !== prevKeys[i]);

    if (!keysChanged) {
      // Just update values/colors without refetching coordinates

      // setCountryData((prevData) =>
      //   prevData.map((item) => ({
      //     ...item,
      //     value: DDPValues[0][item.name] || "",
      //     icon:
      //       DDPValues[0][item.name] !== ""
      //         ? DDPValues[0][item.name] !==
      //           [...new Set(Object.values(DDPValues[0]))].sort(
      //             (a, b) => a - b
      //           )[1]
      //           ? blueLocation
      //           : greenPin
      //         : yellowPin,
      //     color:
      //       DDPValues[0][item.name] !== ""
      //         ? DDPValues[0][item.name] !==
      //           [...new Set(Object.values(DDPValues[0]))].sort(
      //             (a, b) => a - b
      //           )[1]
      //           ? 0x4a4aff
      //           : 0x007f00
      //         : 0x4a4aff,
      //   }))
      // );

      const values = Object.values(DDPValues[0]).filter((v) => v !== "");
      const minValue = Math.min(...values);

      setCountryData((prevData) =>
        prevData.map((item) => {
          const value = DDPValues[0][item.name] || "";
          const isMin = value !== "" && value === minValue;

          return {
            ...item,
            value: value,
            icon:
              value === ""
                ? yellowPin
                : isMin
                ? greenPin
                : item?.name === selectedHeader
                ? yellowPin
                : blueLocation,
            color: value === "" ? 0x4a4aff : isMin ? 0x007f00 : 0x4a4aff,
          };
        })
      );

      return;
    }

    // Save current keys for next comparison
    prevKeysRef.current = currentKeys;

    const fetchCountryData = async () => {
      try {
        const updatedDDPValues = {
          ...DDPValues[0],
          [selectedHeader]: "",
        };

        const values = Object.values(updatedDDPValues);
        const uniqueValues = [...new Set(values)].sort((a, b) => a - b);
        const secondLowestValue =
          uniqueValues.length > 1 ? uniqueValues[1] : undefined;

        const coordinatePromises = Object.keys(updatedDDPValues).map(
          async (key) => {
            const coordinates = await getCountryCoordinates(key);
            if (coordinates) {
              return {
                name: key,
                value: updatedDDPValues[key],
                latitude: coordinates.latitude,
                longitude: coordinates.longitude,
                icon:
                  updatedDDPValues[key] !== ""
                    ? updatedDDPValues[key] !== secondLowestValue
                      ? blueLocation
                      : greenPin
                    : yellowPin,
                color:
                  updatedDDPValues[key] !== ""
                    ? updatedDDPValues[key] !== secondLowestValue
                      ? 0x4a4aff
                      : 0x007f00
                    : 0x4a4aff,
              };
            }
            return null;
          }
        );

        const results = await Promise.all(coordinatePromises);
        setCountryData(results.filter(Boolean));
      } catch (error) {}
    };

    fetchCountryData();
  }, [DDPValues, selectedHeader]);

  useEffect(() => {
    if (!selectedHeader) return;
    let root = am5.Root.new("chartdivMap");

    root.setThemes([am5themes_Animated.new(root)]);

    root.container.setAll({
      width: am5.percent(100),
      height: am5.percent(100),
      layout: root.horizontalLayout,
    });
    // Create map chart
    let map = root.container.children.push(
      am5map.MapChart.new(root, {
        projection: am5map.geoNaturalEarth1(),
        // projection: am5map.geoMercator(),
        panX: "rotateX",
        panY: "translateY",
        wheelY: "zoom",
      })
    );

    // Add polygon series for base map
    let polygonSeries = map.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldIndiaLow,
        exclude: ["AQ"],
        fill: am5.color("#D3D3D3"),
      })
    );

    polygonSeries.mapPolygons.template.setAll({
      // tooltipText: "{name}",
      toggleKey: "active",
      interactive: true,
      stroke: am5.color("#D3D3D3"),
      strokeWidth: 0,
    });

    let pointSeries = map.series.push(am5map.MapPointSeries.new(root, {}));
    let colorSet = am5.ColorSet.new(root, { step: 2 });

    // Choose a starting country for the lines
    let startingCountry1 = countryData.find(
      (c) => c.name.toLowerCase() === selectedHeader.toLowerCase()
    );
    let startingCountry = countryData[0];

    // Fallback to first country if selectedHeader not found
    if (!startingCountry) startingCountry = countryData[0];
    for (const key in countryData) {
      if (
        countryData.value === "" ||
        countryData.value === null ||
        countryData.value === undefined
      ) {
        startingCountry = countryData[key];
      }
    }
    // // Line series for connections
    let lineSeries = map.series.push(
      am5map.MapLineSeries.new(root, {
        // lineType: "straight"
      })
    );

    lineSeries.mapLines.template.setAll({
      strokeWidth: 2,
      strokeOpacity: 1,
      strokeDasharray: [4, 4],
      curvature: 0.9,
    });

    function getColorByCountry(countryName) {
      const country = countryData.find((c) => c.country === countryName);
      return country ? country.color : 0x000000;
    }

    // Function to update line color dynamically based on country
    function updateLineColorByCountry(countryName) {
      const colorHex = getColorByCountry(countryName);
      lineSeries.mapLines.template.set("stroke", am5.color(colorHex));
    }

    // Function to update line colors for all countries in countryData
    function updateAllLineColors() {
      countryData.forEach((country) => {
        updateLineColorByCountry(country.country);
      });
    }

    const lineColor = [0xff0000, 0xffff00, 0x00ff00, "#FF33A6", "#33FFF3"];

    countryData &&
      countryData.forEach((d, index) => {
        // Skip line from starting country to itself
        if (d && d.name !== startingCountry1.name) {
          // Cycle through color palette for each line
          // const lineColor = colors[index % colors.length];
          const lineColor = d.color;

          // Create a new MapLine with specified properties
          const line = lineSeries.pushDataItem({
            geometry: {
              type: "LineString",
              // type: "straight",
              coordinates: [
                [startingCountry1.longitude, startingCountry1.latitude],
                [d.longitude, d.latitude],
              ],
            },
          });

          // Set line-specific properties after creation
          line.get("mapLine").setAll({
            stroke: am5.color(lineColor), // Dynamic color for each line
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDasharray: [4, 4], // Optional dashed line
            curvature: 0.1, // Adjust curvature if needed
          });
        }
        const startCoord = [
          startingCountry1.longitude,
          startingCountry1.latitude,
        ];
        const endCoord = [d.longitude, d.latitude];
        // Calculate the midpoint for arrow placement
        const midpoint = [
          (startCoord[0] + endCoord[0]) / 2,
          (startCoord[1] + endCoord[1]) / 2,
        ];
        const lineColor = d.color;
        // Create arrow for each line dynamically at its midpoint
        const arrowSeries = map.series.push(
          am5map.MapPointSeries.new(root, {})
        );
        // arrowSeries.bullets.push(() => {
        //   const arrow = am5.Graphics.new(root, {
        //     fill: am5.color(lineColor),
        //     stroke: am5.color(lineColor),
        //     draw: (display) => {
        //       display.moveTo(0, 1);
        //       display.lineTo(8, 0);
        //       display.lineTo(0, 3);
        //       display.lineTo(0, -2);
        //     },
        //   });

        //   return am5.Bullet.new(root, {
        //     sprite: arrow,
        //   });
        // });

        // // // Dynamically add arrow data for each midpoint
        // arrowSeries.data.push({
        //   geometry: { type: "Point", coordinates: midpoint },
        // });
        // Add data for each point
        pointSeries.data.push({
          geometry: { type: "Point", coordinates: [d.longitude, d.latitude] },
          title: d.name,
          value: d.value,
          icon: d.icon,
        });
      });

    pointSeries.bullets.push((root, series, dataItem) => {
      const iconUrl = dataItem.dataContext.icon;

      // Create a container for the bullet with vertical layout
      const bulletContainer = am5.Container.new(root, {
        centerX: am5.p50,
        centerY: am5.p50,
        layout: root.verticalLayout, // Stack elements vertically
      });

      // Create the picture (icon)
      const icon = am5.Picture.new(root, {
        src: iconUrl,
        width: 25,
        height: 25,
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
        }),
        cursorOverStyle: "pointer",
        tooltipY: 0,
        y: 20,
        visible: true,
        centerX: am5.p50,
        centerY: am5.p50,
      });

      // Create the label styled as a tooltip
      const label = am5.Label.new(root, {
        text: `${dataItem.dataContext.title} ${
          dataItem.dataContext.value
            ? `: ${currency?.currency_symbol}${dataItem.dataContext.value}`
            : ""
        }`,

        fontSize: 12,
        fill: am5.color(0x333333), // Dark gray text color
        centerX: am5.p50,
        paddingBottom: 5,
        paddingTop: 5,
        background: am5.RoundedRectangle.new(root, {
          fill: am5.color(0xccccff), // Light purple background color
          fillOpacity: 0.5, // Fully opaque
          cornerRadiusTL: 5,
          cornerRadiusTR: 5,
          cornerRadiusBL: 5,
          cornerRadiusBR: 5,
          paddingLeft: 10,
          paddingRight: 10,
          shadowColor: am5.color(0x000000), // Optional drop shadow
          shadowBlur: 5,
        }),
        y: -15,
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
        }),
      });

      // Create the triangle (tooltip bump)
      const triangle = am5.Triangle.new(root, {
        width: 10,
        height: 5,
        centerX: am5.p50,
        centerY: am5.p50,
        fill: am5.color(0xccccff), // Same color as the label background
        rotation: 180, // Rotate to point downwards
      });

      // Add the label and triangle above the icon in the container
      bulletContainer.children.push(label);
      bulletContainer.children.push(triangle); // Triangle between label and icon
      bulletContainer.children.push(icon);

      // Create the bullet with the container as its sprite
      return am5.Bullet.new(root, {
        sprite: bulletContainer,
      });
    });

    // map.set("zoomControl", am5map.ZoomControl.new(root, {}));
    // Create ZoomControl and add it to the map
    let zoomControl = am5map.ZoomControl.new(root, {
      layout: root.verticalLayout, // Keep buttons stacked vertically
    });

    map.set("zoomControl", zoomControl);

    zoomControl.setAll({
      x: am5.percent(100),
      y: am5.percent(0),
      centerX: am5.p100,
      centerY: am5.p0,
    });

    map.set("zoomLevel", 1.15);

    root._logo.dispose();

    return () => {
      root.dispose();
    };
  }, [countryData, DDPValues]);

  return (
    <div
      id="chartdivMap"
      style={{ width: "100%", height: "350px", margin: 0, padding: 0 }}
    ></div>
  );
};

export default MapChart;
